export default import.meta.ROLLDOWN_FILE_URL_g9Yp6oRmkqkn9cGwcNsiTw